/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:97062840-555a-4da9-b582-7743300f7ee1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_mjWYUuhwh",
    "aws_user_pools_web_client_id": "3gpubo0nh1u3gckr5ot22i0m5k",
    "oauth": {
        "domain": "dailyreportprojectb01ddc55-b01ddc55-studyprod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3002/,https://dailyreport.brainqtech.com/,https://care.brainqtech.com/",
        "redirectSignOut": "http://localhost:3002/,https://dailyreport.brainqtech.com/,https://care.brainqtech.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "DailyReport-Clinics-studyprod",
            "region": "us-east-1"
        },
        {
            "tableName": "DailyReport-Invites-studyprod",
            "region": "us-east-1"
        },
        {
            "tableName": "DailyReport-PatientRequests-studyprod",
            "region": "us-east-1"
        },
        {
            "tableName": "DailyReport-Topics-studyprod",
            "region": "us-east-1"
        },
        {
            "tableName": "DailyReport-UserData-studyprod",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "daily-report-storage03515-studyprod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
